module.exports = __webpack_public_path__ + "img/session.ce37800c.png";